import CookieManager from "./CookieManager";
import { REPEAT_USER_COOKIE_NAME, USER_VISIT_STATUS } from "../Constants/evaluation";
import { UNKNOWN } from "../Constants/locations";
import UserSession from "./UserSession";
import { getAcquisitionChannelTrackingValues } from "./LayoutHelper";
import LocalStorageHelper from "./LocalStorageHelper";
var TrackingInfoManager = {
  getTrackingInfo: function getTrackingInfo(param) {
    var trackingInfo = Object.assign({
      user_type: CookieManager.readCookie(REPEAT_USER_COOKIE_NAME) ? USER_VISIT_STATUS.REPEAT : USER_VISIT_STATUS.FIRST_TIME,
      browsing_location_id: param.browsing_location_id || UNKNOWN,
      browsing_mode: param.browsing_mode,
      origin: param.origin,
      select_from: param.select_from || UserSession.getTabName().toLowerCase()
    }, getAcquisitionChannelTrackingValues());
    if (param.flow_type) {
      trackingInfo['flow_type'] = param.flow_type;
    }
    if (param.chosen_option) {
      trackingInfo['chosen_option'] = param.chosen_option;
    }
    if (param.variants_shown) {
      trackingInfo['variants_shown'] = param.variants_shown;
    }
    if (param.reason) {
      trackingInfo.reason = param.reason;
    }
    if (param.resultset_type) {
      trackingInfo.resultset_type = param.resultset_type;
    }
    var lead_id = LocalStorageHelper.getItem('lead_id');
    if (lead_id) {
      trackingInfo.lead_id = lead_id;
    }
    return trackingInfo;
  }
};
export default TrackingInfoManager;